export default "__VITE_PUBLIC_ASSET__23985538__"